import { updateObject } from '../utility';

const initialState = {
  countrySlotsData: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_COUNTRY_SLOTS_DATA': {
      return updateObject(state, {
        countrySlotsData: action.payload,
      });
    }
    default:
      return state;
  }
};

export default reducer;
